import { escapeHtml } from '../inventoree/format'

/**
 * Coloanele registrului de domenii - CmdbRecords din public/js/cmdb/records.js,
 * cu acelasi HTML pe celula. Culorile de expirare vin de la server
 * (DueState / Ci_records::dueState); aici doar se deseneaza.
 */

export interface DomainService {
  id: number
  name: string
  class?: string
  kind?: number
}

export interface DomainRow {
  DT_RowId: string
  ID: number
  name: string
  company_name: string | null
  props: Record<string, unknown>
  services: DomainService[]
  due_date: string | null
  due_days: number | null
  due_state: 'none' | 'expired' | 'soon' | 'ok'
}

export interface DomainColumnDef {
  key: string
  label: string
  type: 'text' | 'boolean' | 'code'
}

export const DOMAIN_COLUMNS: DomainColumnDef[] = [
  { key: 'registrar', label: 'Registrar', type: 'text' },
  { key: 'dns_hosting', label: 'DNS', type: 'text' },
  { key: 'auto_renew', label: 'Auto renew', type: 'boolean' },
  { key: 'transfer_lock', label: 'Locked', type: 'boolean' },
]

const MUTED = '<span class="adm-muted">&mdash;</span>'

export function muted(): string {
  return MUTED
}

/** dueCell din records.js */
export function dueCell(row: DomainRow): string {
  if (!row.due_date) return muted()
  const label = escapeHtml(row.due_date)
  if (row.due_state === 'expired') {
    return `<span class="adm-pill adm-pill-danger">${label} &middot; expired</span>`
  }
  if (row.due_state === 'soon') {
    return `<span class="adm-pill adm-pill-warning">${label} &middot; ${row.due_days}d left</span>`
  }
  return label
}

/** servicesCell din records.js - primele trei si un numar. */
export function servicesCell(row: DomainRow, cmdbUrl = 'cmdb'): string {
  const list = row.services || []
  if (!list.length) return '<span class="adm-muted">nothing recorded</span>'
  let shown = list
    .slice(0, 3)
    .map((service) => `<a href="${cmdbUrl}/view/${service.id}">${escapeHtml(service.name)}</a>`)
    .join(', ')
  if (list.length > 3) {
    shown += ` <span class="adm-muted">+${list.length - 3} more</span>`
  }
  return shown
}

export function nameCell(row: DomainRow, cmdbUrl = 'cmdb'): string {
  return `<a href="${cmdbUrl}/view/${row.ID}">${escapeHtml(row.name)}</a>`
}

export function companyCell(value: string | null): string {
  return value ? escapeHtml(value) : muted()
}

export function propCell(row: DomainRow, column: DomainColumnDef): string {
  const value = (row.props || {})[column.key]
  if (value === null || value === undefined || value === '') return muted()
  if (column.type === 'boolean') return parseInt(String(value), 10) === 1 ? 'Yes' : 'No'
  if (column.type === 'code') return `<code>${escapeHtml(value)}</code>`
  return escapeHtml(value)
}
